import { render, staticRenderFns } from "./YiShiDaLabelDialog.vue?vue&type=template&id=cbb36b28&scoped=true"
import script from "./YiShiDaLabelDialog.vue?vue&type=script&lang=js"
export * from "./YiShiDaLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./YiShiDaLabelDialog.vue?vue&type=style&index=0&id=cbb36b28&prod&scoped=true&lang=css"
import style1 from "./YiShiDaLabelDialog.vue?vue&type=style&index=1&id=cbb36b28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb36b28",
  null
  
)

export default component.exports